export enum AuditableStatus {
    OPEN = 'open',
    RESOLVED = 'resolved',
}
